<!-- 影像馆头部组件 -->
<template>
  <div class="searchitme">
    <div class="search-wrap acea-row row-center-wrapper">
      <div class="search-input-wrap acea-row row-middle">
        <input type="" name="" id="" v-model="kwd" @keyup.enter="search" />
        <!-- <div class="seach-select-wrap acea-row row-center-wrapper">
          <div @click.stop="seachSelectShow = true">
            {{ searchType === 1 ? "精品图片" : "精品视频" }}
          </div>
          <div
            class="select-menu"
            :class="seachSelectShow ? 'select-menu-show' : ''"
          >
            <div
              @click.stop="
                searchType = 0;
                seachSelectShow = false;
              "
              :class="searchType === 0 ? 'active' : ''"
              class="select-menu-item acea-row row-center-wrapper"
            >
              精品图片
            </div>
            <div
              @click.stop="
                searchType = 1;
                seachSelectShow = false;
              "
              :class="searchType === 1 ? 'active' : ''"
              class="select-menu-item acea-row row-center-wrapper"
            >
              精品视频
            </div>
          </div>
        </div> -->
      </div>
      <div class="search-btn acea-row row-center-wrapper" @click="search">
        <span>搜索</span>
      </div>

      <div
        style="
          width: 800px;
          height: 160px;
          margin-top: 420px;
          position: absolute;
        "
      >
        <span class="poto" style="background-color: green; float: right"
          ><p>图片</p>
          <span>图片</span></span
        >
        <span class="poto" style="background-color: green; float: left"
          ><p>图片</p>
          <span>图片</span></span
        >

        <el-avatar
          style="background-color: green; margin-left: 140px"
          :size="110"
        ></el-avatar>
        <div class="title">{{photoname}}</div>

        <el-menu  v-if="photoindex=='photoindex'"
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="1">主页</el-menu-item>
          <el-menu-item index="2">图片</el-menu-item>
          <el-menu-item index="3">视频</el-menu-item>
          <el-menu-item index="4">活动</el-menu-item>
        </el-menu>
        <el-menu v-if="grapher=='grapher'"
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
        >
          <el-menu-item index="2">图片</el-menu-item>
          <el-menu-item index="3">视频</el-menu-item>
        </el-menu>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "searchitme",
 props: {
  photoindex: {
    type: String,
  }, 
  grapher: {
    type: String,
  },

},
  data() {
    return {
      kwd: "",
      seachSelectShow: true,
      imgSelectList: [],
      videoSelectList: [],
      photographerSelectList: [],
      newImgList: [],
      newVideoList: [],
      searchType: 0,
      activeIndex: "1",
      photoname: "数据命名",
    };
  },
  methods: {
    search() {
      console.log();
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.$emit('func',key)
    },
  },
};
</script>
<style>
.searchitme {
  min-width: 1200px;
  width: 100%;
  height: 590px;
  background-color: #ffffff;
  border-bottom: 2px solid #999999;
}
.search-wrap {
  min-width: 1200px;
  width: 100%;
  height: 400px;
  background-color: #ffffff;
  /* border-bottom: 1px solid #E5E5E5; */
  padding: 0 44px;
  background-image: url("../imgs/1514389.jpg");
  background-size: cover;
  background-position: center;
  /* background: url('../imgs/Group.png') no-repeat center / cover; */
}

.search-input-wrap {
  width: 742px;
  height: 60px;
  background: #f5f5f5;
  border: 1px solid #e5e5e5;
}

.search-btn {
  width: 190px;
  height: 60px;
  background: #dc3b3b;
  border-radius: 0px 3px 3px 0px;
  font-size: 24px;
  color: #ffffff;
  cursor: pointer;
}
.search-btn > img {
  width: 19px;
  height: 19px;
  margin-right: 15px;
}

input {
  background-color: transparent;
  border: none;
  outline: none;
  flex: 1;
  height: 90%;
  padding-left: 30px;
}

.seach-select-wrap {
  width: 172px;
  height: 100%;
  font-size: 18px;
  color: #999999;
  position: relative;
  cursor: pointer;
}

.seach-select-wrap::before {
  content: "";
  height: 32px;
  border-left: 1px solid #999999;
  position: absolute;
  left: 0;
  top: 50%;
  margin-top: -16px;
}

.seach-select-wrap::after {
  content: "";
  width: 13px;
  height: 13px;
  /* background: url(img/arrow-down.svg) no-repeat center / contain; */
  position: absolute;
  right: 20px;
  top: 50%;
  margin-top: -6.5px;
}

.select-menu {
  position: absolute;
  width: 172px;
  height: 0;
  /* background-color: #f00; */
  bottom: 0;
  transform: translate(0, 100%);
  overflow: hidden;
  /* transition: all 0.3s; */
  opacity: 0;
}

.select-menu.select-menu-show {
  height: 154px;
  opacity: 1;
}

.select-menu-item {
  width: 172px;
  height: 76px;
  font-size: 18px;

  background: #faf9f9;
  color: #999999;
}
.select-menu-item.active {
  background: #db3a3b;
  color: #ffffff;
}
.acea-row.row-center-wrapper {
  align-items: center;
  justify-content: center;
}
.acea-row {
  display: flex;
  flex-wrap: wrap;
}
.poto {
  width: 200px;
  height: 70px;
  font-size: 22px;
  text-align: center;
}
.title {
  text-align: center;
  font-size: 42px;
}
.el-menu-demo {
  display: flex;
  justify-content: center;
  font-size: 16px;
  height: 74px;
}
</style>


// WEBPACK FOOTER //
// src/components/searchitme.vue